import React from 'react'
import { useStore } from '../Store/useStore'

const FilterTag = ({ filter }) => {
    const setFilterState = useStore((state) => state.setFilterState)
    const activeFilterTagUids = useStore((state) => state.activeFilterTagUids)
    const showFilterCount = useStore((state) => state.showFilterCount)

    const checked = activeFilterTagUids.includes(filter.uid)

    const handleChange = () => {
        setFilterState(filter.uid, !checked)
    }

    const getFilterCount = () => {
        if (!showFilterCount) {
            return null
        }

        return <span className="journal-list__filter-item-count">{filter.count}</span>
    }

    return (
        <label className="journal-list__filter-item">
            <input type="checkbox" checked={checked} onChange={handleChange} />
            <span className="journal-list__filter-item-name">{filter.name}</span>
            {getFilterCount()}
        </label>
    )
}

export default FilterTag
